module.exports = __webpack_public_path__ + "static/media/facebook-white.995a5b5a.webp";